import type { Territory } from './OperationZones.type';

export const isTerritoryCompatibleWithBrand = (
    territory: Pick<Territory, 'currencies'>,
    brandCurrency: string | null,
    hasOpZoneRestaurant: boolean,
): boolean => {
    if (!hasOpZoneRestaurant || !brandCurrency) return true;
    return territory.currencies.includes(brandCurrency);
};
